import api from './client';

export const listConversations = async () => {
  const res = await api.get('/messages/conversations');
  return res.data;
};

export const getThread = async (username) => {
  const res = await api.get(`/messages/with/${encodeURIComponent(username)}`);
  return res.data;
};

export const sendMessage = async (username, body) => {
  const res = await api.post(`/messages/with/${encodeURIComponent(username)}`, { body });
  return res.data;
};

export const unreadCount = async () => {
  const res = await api.get('/messages/unread-count');
  return res.data;
};

// Phase 18.3 — typing indicator ping. Self-expires server-side after 5s.
export const pingTyping = async (username) => {
  const res = await api.post(`/messages/with/${encodeURIComponent(username)}/typing`);
  return res.data;
};

// Phase F4 — Voice-First messaging home: conversations + ♡ Preferiti.
export const getContacts = async () => {
  const res = await api.get('/messages/contacts');
  return res.data;
};

// Phase F4 — "Elimina conversazione" (per-user hide, non destructive).
export const deleteConversation = async (username) => {
  const res = await api.delete(`/messages/with/${encodeURIComponent(username)}`);
  return res.data;
};

// Phase F4 — 🎁 Tip in chat (Voce Pro only). clientRef = idempotency key.
export const sendChatTip = async (username, amount, clientRef) => {
  const res = await api.post(`/messages/with/${encodeURIComponent(username)}/tip`, {
    amount,
    client_ref: clientRef,
  });
  return res.data;
};
